import { isEmail } from '@seek/validators-js';

export default (value: string) =>
  isEmail.test({ value, validatorProps: {}, formValues: {} });
